import React, { Component } from 'react'
import Link from 'gatsby-link'

import { Flex, Text } from './Layout'
import { List, ListItem } from './Typography'

const Foot = Flex.withComponent('footer')

const Footer = ({ post }) => (
  <Foot
    mt="auto"
    mb={[3, 3, 4]}
    align="center"
    justify={['center', 'center', 'space-between']}
    fontFamily="monospace"
  >
    <List>
      <ListItem display="inline-block" mr={4}>
        <Link to="/legal_notice/">
          <Text
            color="lightgrey"
            hover={{ color: 'orange' }}
            fontSize={[-1, 0]}
          >
            Legal Notice
          </Text>
        </Link>
        <Text color="lightgrey" hover={{ color: 'orange' }} fontSize={[-1, 0]}>
          {' '}
          /{' '}
        </Text>
        <Link to="/impressum/">
          <Text
            color="lightgrey"
            hover={{ color: 'orange' }}
            fontSize={[-1, 0]}
          >
            Impressum
          </Text>
        </Link>
      </ListItem>
      <ListItem display="inline-block" mr={4}>
        <Link to="/privacy_policy/">
          <Text
            color="lightgrey"
            hover={{ color: 'orange' }}
            fontSize={[-1, 0]}
          >
            Privacy Policy
          </Text>
        </Link>
        <Text color="lightgrey" hover={{ color: 'orange' }} fontSize={[-1, 0]}>
          {' '}
          /{' '}
        </Text>
        <Link to="/datenschutz_erklaerung/">
          <Text
            color="lightgrey"
            hover={{ color: 'orange' }}
            fontSize={[-1, 0]}
          >
            Datenschutzerkl&auml;rung
          </Text>
        </Link>
      </ListItem>
    </List>
  </Foot>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js